var _rect, _rect2, _rect3, _rect4, _circle, _rect5, _path, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 100,
    fill: "#F0F3F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-190 -414)",
    fill: "#F5F6F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -126,
    y: -260,
    width: 1311,
    height: 804,
    rx: 8,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -72.5,
    y: -58.5,
    width: 246,
    height: 313,
    rx: 7.5,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#F5F7FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -72.5,
    y: -58.5,
    width: 246,
    height: 313,
    rx: 7.5,
    stroke: "#A7AABD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.333 65H57.6663M50.9997 58.3333V65M37.6663 35H64.333C66.174 35 67.6663 36.4924 67.6663 38.3333V55C67.6663 56.8409 66.174 58.3333 64.333 58.3333H37.6663C35.8254 58.3333 34.333 56.8409 34.333 55V38.3333C34.333 36.4924 35.8254 35 37.6663 35Z",
    stroke: "#2B5297",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -20323,
    y: -33653,
    width: 53660,
    height: 41487,
    stroke: "black",
    strokeWidth: 50
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicManagement);
export default __webpack_public_path__ + "static/media/topic-management.f8bc6ac76b87939b13f0fa756788ea2c.svg";
export { ForwardRef as ReactComponent };